module.exports = __webpack_public_path__ + "lang/pt.json";


//////////////////
// WEBPACK FOOTER
// ./lang/pt.json
// module id = 118
// module chunks = 3